import { Modal, Button } from '../ui';
import { companyInfo } from '../../data';

export interface AboutModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export function AboutModal({ isOpen, onClose }: AboutModalProps) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Despre noi" size="md">
            <div className="space-y-4">
                <p className="text-gray-700 font-font-s leading-relaxed">
                    <span className="font-semibold">www.starinsurance.ro</span> este operat de catre societatea
                    comerciala <span className="font-semibold text-main-color">{companyInfo.name}</span>, care este
                    inregistrata in Registrul Comertului sub nr.{' '}
                    <span className="font-medium">{companyInfo.registruComert}</span>, CUI{' '}
                    <span className="font-medium">{companyInfo.cui}</span>.
                </p>

                <p className="text-gray-700 font-font-s leading-relaxed">
                    Societatea este inregistrata la ASF cu codul unic{' '}
                    <span className="font-semibold text-main-color">{companyInfo.registrationCode}</span> ca asistent in
                    brokeraj al{' '}
                    <a
                        href={companyInfo.partner.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-green-600 hover:text-green-800 font-semibold"
                    >
                        {companyInfo.partner.name}
                    </a>
                    .
                </p>

                <div className="bg-gray-50 rounded-lg p-4 mt-4">
                    <h4 className="font-font-s font-semibold text-text-color mb-2">Sediul Social:</h4>
                    <p className="text-gray-600 font-font-s text-sm">
                        {companyInfo.address.street}
                        <br />
                        Cod postal {companyInfo.address.postalCode}
                        <br />
                        {companyInfo.address.city}, {companyInfo.address.county}
                    </p>
                </div>
            </div>

            <div className="mt-6 flex justify-end">
                <Button onClick={onClose} variant="primary">
                    Inchide
                </Button>
            </div>
        </Modal>
    );
}
